var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11V10C2.5 9.44772 2.94771 9 3.5 9H5.62328C5.73076 9 5.83754 8.98267 5.9395 8.94869L8.55544 8.07672C8.7067 8.02631 8.86782 8.01279 9.02537 8.03729L9.28015 8.07693C10.2662 8.23031 10.444 9.5748 9.53173 9.97923L8.35704 10.5L12.2005 9.08009C12.8307 8.84728 13.5 9.31355 13.5 9.98537C13.5 10.3603 13.2828 10.7014 12.943 10.8599L8.69834 12.8407C8.47835 12.9434 8.22852 12.9625 7.99547 12.8945L5.06554 12.04C4.97457 12.0135 4.8803 12 4.78554 12H3.5C2.94772 12 2.5 11.5523 2.5 11Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 2,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCollect);
export default __webpack_public_path__ + "static/media/payment-collect.840c758355aad0dbd037cf5f7615e1c4.svg";
export { ForwardRef as ReactComponent };